<template>
  <div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "bounce",
  data() {
    return {
      launch_proto: "",
    }
  },
  components: {
  },
  created() {
  },
  methods: {
  },
  computed: {
  },
  mounted() {
    let vue = this;
    let cfg = vue.$router.currentRoute.params.cfg;
    if (!cfg) {
       vue.$router.push({ name: 'login' });
       return;
    }
    let j;
    if (cfg.charAt(0) == "{") {
      /* It appears the params.cfg has, in effect, already had
       *  decodeURIComponent called twice on it. Doing so again
       *  will undo the encoding on the internal j.creds.me */
      j = to_json(cfg);
    } else {
      j = to_json(b64_extract(cfg));
    }
    if (vx && vx.debug) { console.log("BOUNCE:",cfg,j); }
    if (!j) {
       vue.$router.push({ name: 'login' });
       return;
    }
    if (j.provider == "slack") {
      /* Because slack has various teams/workspaces it is better
         to ignore any existing credentials. SignOut and start
         sign-in-with-slack flow for the specifically requested
         teamid */
      if (!j.tid) {
        console.warn("Slack requires a teamid");
        return;
      }
      if (j.path) {
        setLocal("vx_page_href",j.path);
      }
      vx_api
       .signOut(window.vx)
       .then(data => {
          vue.$parent.slSignIn(""+j.tid);
       }).catch(e => {
          vue.$parent.slSignIn(""+j.tid);
       });
      return;
    } else if (vue.$parent.isAuth()) {
      /* Already Authenticated */
      if (vx && vx.debug) { console.log("Bounce authed",j.path); }
      if (j.path) {
        eraseLocal("vx_page_href");
        vue.$router.push({ path: j.path });
        return;
      }
    } else if (j.provider == "guest") {
      if (j.path) {
        setLocal("vx_page_href",j.path);
      } else {
        setLocal("vx_page_href","_default");
      }
      if (j.xtr) {
        window.vx.guestQuestion = ""+j.xtr;
        vue.$parent.leaveMsgText = ""+j.xtr;
      }
      vx_api.getSelf(window.vx,j.creds.me).then(self_res => {
        setLocal("vx_cred_me",j.creds.me);
        vue.$user.set(Object.assign({
          role: "authenticatedUser"
        },
        self_res));
        continue_to_page(vue.$router,true);
      });
      return;
    } else {
      if (vx && vx.debug) { console.log("Bounce login",j.provider,j.path); }
      if (j.path) {
        setLocal("vx_page_href",j.path);
      }
      if (j.provider) {
        vue.$router.push({ name: 'login', params:{provider: j.provider}});
        return;
      }
    }
    vue.$router.push({ name: 'login' });
  },
};
</script>

<style lang="scss" scoped>
</style>
